import {InputTitleNormal} from '../../common/TitleStyle'
import styled from '@emotion/styled'

const HealthConditionSubTitle = styled(InputTitleNormal)(({theme}) => ({
  marginBottom: theme.spacing(3),
  marginLeft: theme.spacing(1),
  color: theme.palette.grey[600]
}))

export {HealthConditionSubTitle}
